module.exports = __webpack_public_path__ + "static/media/title3.336f9549.jpg";